import styles from './ComplimentariesCollapsePanel.css'
import CollapsePanel from '../CollapsePanel/CollapsePanel'
import { Row, Col } from 'antd'
import ImageFunctionTable from '../ImageFunctionTable/ImageFunctionTable'

const getHeader = params => {
  const {
    title,
    subTitle
  } = params

  return (
    <Row
      className={styles.headerRow}
      type='flex'
      justify='space-between'
      align='middle'
    >
      <Col span={4}>
        <div className={styles.headerTitle}>
          {title}
        </div>
      </Col>
      <Col span={20}>
        <div className={styles.headerSubTitle}>
          {subTitle}
        </div>
      </Col>
    </Row>
  )
}

const ComplimentariesCollapsePanel = props => {
  const {
    readOnly,
    modelsFieldName,
    models,
    modelSpecHeader,
    title = '',
    subTitle = ''
  } = props

  const header = getHeader({ title, subTitle })

  return (
    <CollapsePanel
      panelHeader={header}
      defaultExpanded={false}
    >
      <ImageFunctionTable
        readOnly={readOnly}
        enableSync={false}
        models={models}
        modelSpecHeader={modelSpecHeader}
        modelsFieldName={modelsFieldName}
        hasDistinctSizesUploader
        isNoModelsListing
        isExtraModel
      />
    </CollapsePanel>
  )
}

export default ComplimentariesCollapsePanel
